import script from "./OverlayComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./OverlayComponent.vue?vue&type=script&setup=true&lang=js"

import "./OverlayComponent.vue?vue&type=style&index=0&id=2980102c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2980102c"]])

export default __exports__